import styled, { css } from 'styled-components';
import { Icon } from '@metaicg/sensei-ui';
import { useCallback, useLayoutEffect, useState } from 'react';

const hoverSlide = css`
  @keyframes hoverSlide {
    0% {
      translate: 0;
    }
    100% {
      translate: 2px;
    }
  }

  &:hover {
    animation: hoverSlide 0.2s ease-in-out infinite alternate;
    animation-delay: 1s;
  }
`;

const CollapseButtonStyled = styled.div<{ collapsed: boolean; size: number }>`
  position: absolute;
  top: -${({ size }) => size / 2}px;
  right: -${({ size }) => size / 2}px;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all ease-out ${({ theme }) => theme.transitions.duration.fast}ms;
  background-color: ${({ theme }) => theme.colors.neutral.background};
  border: 1px solid ${({ theme }) => theme.colors.neutral.palette600};
  border-radius: ${({ theme }) => theme.radii.round}px;
  z-index: ${({ theme }) => theme.zIndices.dropdown};
  transform: ${({ collapsed }) => (collapsed ? 'rotate3d(0, 0, 1, 180deg)' : 'rotate3d(0, 0, 1, 0deg)')};

  svg {
    fill: ${({ theme }) => theme.colors.neutral.palette500};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.palette500};
    border-color: ${({ theme }) => theme.colors.primary.palette500};
    box-shadow: ${({ theme }) => theme.shadows.lg};

    svg {
      fill: ${({ theme }) => theme.colors.neutral.white};
    }
  }

  // Animations
  ${hoverSlide}
`;
const CollapseButton = ({ onClick, ...props }: { collapsed: boolean; onClick: (collapsed: boolean) => void }) => {
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed);
  const onCollapse = useCallback(
    (collapsed: boolean) => {
      setIsCollapsed(collapsed);
      onClick(collapsed);
    },
    [onClick]
  );

  useLayoutEffect(() => {
    onCollapse(props.collapsed);
  }, [props.collapsed, onCollapse]);

  return (
    <CollapseButtonStyled collapsed={isCollapsed} onClick={() => onCollapse && onCollapse(!isCollapsed)} size={22}>
      <Icon name="arrow-drop-left-line" size={18} />
    </CollapseButtonStyled>
  );
};

export default CollapseButton;
